import { useAtom, useSetAtom } from "jotai";
import { useState } from "react";
import { useParams } from "react-router-dom";
import { isGuidanceActiveAtom } from "../components/DittoGuidance/ctx";
import {
    isFilterChangeConfirmationModalOpenAtom,
    pendingFilterChangeAtom,
} from "../components/FilterChangeConfirmationModal/ctx";
import {
    selectedSubthemesAtomFamily,
    selectedThemesAtomFamily,
    selectedUsersAtomFamily,
} from "../ctx";

export const useObjectiveFilters = () => {
    const { org_uname } = useParams();

    // Filter state
    const [selectedThemesIds, setSelectedThemesIds] = useAtom(
        selectedThemesAtomFamily(org_uname),
    );
    const [themeSearchFilter, setThemeSearchFilter] = useState<string>();

    const [selectedSubthemesIds, setSelectedSubthemesIds] = useAtom(
        selectedSubthemesAtomFamily(org_uname),
    );
    const [subthemeSearchFilter, setSubthemeSearchFilter] = useState<string>();

    const [selectedUserIds, setSelectedUserIds] = useAtom(
        selectedUsersAtomFamily(org_uname),
    );
    const [ownerSearchFilter, setOwnerSearchFilter] = useState<string>();

    // Guidance state
    const [isGuidanceActive] = useAtom(isGuidanceActiveAtom);

    // Filter change confirmation modal state
    const setIsFilterChangeConfirmationModalOpen = useSetAtom(
        isFilterChangeConfirmationModalOpenAtom,
    );
    const setPendingFilterChange = useSetAtom(pendingFilterChangeAtom);

    // Handlers
    const handleThemeChange = (value: (string | null)[]) => {
        if (isGuidanceActive) {
            // Show confirmation modal instead of directly applying the change
            setPendingFilterChange({
                type: "theme",
                newValue: value,
            });
            setIsFilterChangeConfirmationModalOpen(true);
        } else {
            setSelectedThemesIds(value);
        }
    };

    const handleSubthemeChange = (value: (string | null)[]) => {
        if (isGuidanceActive) {
            // Show confirmation modal instead of directly applying the change
            setPendingFilterChange({
                type: "subtheme",
                newValue: value,
            });
            setIsFilterChangeConfirmationModalOpen(true);
        } else {
            setSelectedSubthemesIds(value);
        }
    };

    return {
        // Filter values
        selectedThemesIds,
        selectedSubthemesIds,
        selectedUserIds,

        // Search filters
        themeSearchFilter,
        subthemeSearchFilter,
        ownerSearchFilter,

        // Setters
        setSelectedThemesIds,
        setSelectedSubthemesIds,
        setSelectedUserIds,
        setThemeSearchFilter,
        setSubthemeSearchFilter,
        setOwnerSearchFilter,

        // Handlers
        handleThemeChange,
        handleSubthemeChange,
    };
};
